import { AutoComplete as AutoCompletes } from 'primereact/autocomplete';  

const AutoComplete = ({...rest}) => {

    return (
        <AutoCompletes {...rest} />
    )

};

export default AutoComplete;